import { BrnLabel } from './lib/brn-label';

export * from './lib/brn-label';

export const BrnLabelImports = [BrnLabel] as const;
